import { Globe, RefreshCw, CheckCircle, Lightbulb, Building2, Users, Target, Zap } from 'lucide-react'
import './AICreateCampaign.css'
import '../Pages.css'

const SCRAPE_STEPS = [
  'Fetching website content...',
  'Analyzing company information...',
  'Extracting value proposition...',
  'Identifying pain points...'
]

const tips = [
  { icon: Building2, text: 'Company name & industry are extracted from the homepage.' },
  { icon: Target, text: 'Value proposition and key messaging are identified automatically.' },
  { icon: Users, text: 'Target audience is inferred from the content and messaging.' },
  { icon: Zap, text: 'Pain points are detected from product descriptions and CTAs.' }
]

export default function WebsiteScrapeInput({ url, onUrlChange, onScrape, scraping, activeStep }) {
  const isValidUrl = url.startsWith('http://') || url.startsWith('https://')

  return (
    <div className="campaign-creation-layout">
      {/* Left: URL Input */}
      <div className="card">
        <div className="card-header">
          <h3><Globe size={17} /> Website Analysis</h3>
        </div>
        <div style={{ padding: '1.5rem' }}>
          <div className="form-group">
            <label htmlFor="websiteUrl">Target Company Website URL</label>
            <div style={{ position: 'relative' }}>
              <Globe
                size={16}
                style={{
                  position: 'absolute',
                  left: '0.75rem',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  color: 'var(--color-text-muted)',
                  pointerEvents: 'none'
                }}
              />
              <input
                id="websiteUrl"
                type="url"
                placeholder="https://example.com"
                value={url}
                onChange={(e) => onUrlChange(e.target.value)}
                disabled={scraping}
                style={{ paddingLeft: '2.25rem' }}
              />
            </div>
            <span style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)', marginTop: '0.5rem', display: 'block' }}>
              Enter the full URL including https:// to analyze the prospect's website
            </span>
          </div>

          <button
            onClick={onScrape}
            disabled={!isValidUrl || scraping}
            className="btn btn-ai"
            style={{ width: '100%', marginTop: '1.25rem', padding: '0.75rem', justifyContent: 'center' }}
          >
            {scraping ? (
              <>
                <RefreshCw size={16} className="animate-spin" />
                Analyzing...
              </>
            ) : (
              <>
                <Globe size={16} />
                Analyze Website
              </>
            )}
          </button>

          {scraping && (
            <div className="ai-scrape-progress">
              <div className="ai-scrape-progress-title">
                <RefreshCw size={14} className="animate-spin" />
                Scraping in progress
              </div>
              {SCRAPE_STEPS.map((step, i) => {
                const isDone = i < activeStep
                const isActive = i === activeStep
                return (
                  <div
                    key={i}
                    className={`ai-scrape-step${isActive ? ' active' : ''}${isDone ? ' done' : ''}`}
                  >
                    <div className="ai-scrape-step-icon">
                      {isDone ? (
                        <CheckCircle size={14} style={{ color: '#059669' }} />
                      ) : isActive ? (
                        <RefreshCw size={14} className="animate-spin" style={{ color: '#8b5cf6' }} />
                      ) : (
                        <div className="ai-scrape-step-dot" />
                      )}
                    </div>
                    <span>{step}</span>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </div>

      {/* Right: Tips Panel */}
      <div className="campaign-tips-panel">
        <h4>What gets extracted</h4>
        <ul className="campaign-tips-list">
          {tips.map((tip, i) => {
            const Icon = tip.icon
            return (
              <li key={i}>
                <span className="tip-icon">
                  <Icon size={13} style={{ color: '#8b5cf6' }} />
                </span>
                <span>{tip.text}</span>
              </li>
            )
          })}
        </ul>
        <div style={{
          marginTop: '1.25rem',
          padding: '0.875rem',
          background: 'rgba(139, 92, 246, 0.06)',
          borderRadius: 'var(--radius-md)',
          border: '1px solid rgba(139, 92, 246, 0.15)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.375rem' }}>
            <Lightbulb size={13} style={{ color: '#8b5cf6' }} />
            <span style={{ fontSize: '0.8rem', fontWeight: 600, color: '#7c3aed' }}>Pro Tip</span>
          </div>
          <p style={{ fontSize: '0.8rem', color: 'var(--color-text-secondary)', margin: 0, lineHeight: 1.5 }}>
            Use the company's main marketing page for best results. Avoid login-only pages.
          </p>
        </div>
      </div>
    </div>
  )
}
